import React from 'react';
import PropTypes from 'prop-types';
import ErrorFallback from './ErrorFallback';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, componentStack: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // componentStack is only available in componentDidCatch (not getDerivedStateFromError),
    // so setState here is intentional despite causing a second render.
    this.setState({ componentStack: info.componentStack });
  }

  render() {
    const { hasError, error, componentStack } = this.state;
    const { children } = this.props;
    if (hasError) {
      return <ErrorFallback error={error} componentStack={componentStack} />;
    }
    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ErrorBoundary;
